import type { FC } from 'react';
import type { LinksFunction } from '@remix-run/node';

import clsx from 'clsx';

import type { DbooProtectionPointsProps } from './dboo-protection-points.types';

import styles from './dboo-protection-points.css?url';

export const links: LinksFunction = () => [{ rel: 'stylesheet', href: styles }];

export const DbooProtectionPoints: FC<DbooProtectionPointsProps> = ({
  theme,
  title = 'How do I find out if my data is exposed?',
  firstPointWording = 'Enter your email, name, and location below.',
}) => {
  const containerClassnames = clsx('dboo-protection-points', {
    'dboo-protection-points--light': theme === 'light',
  });

  return (
    <div className="container">
      <div className={containerClassnames}>
        <h2 className="dboo-protection-points__title">{title}</h2>
        <ul className="dboo-protection-points__list">
          <li className="dboo-protection-points__item">
            <span className="dboo-protection-points__number">1</span>
            <p className="dboo-protection-points__description">
              {firstPointWording}
            </p>
          </li>
          <li className="dboo-protection-points__item">
            <span className="dboo-protection-points__number">2</span>
            <p className="dboo-protection-points__description">
              Aura searches for your personal info found on data brokers across
              the web.
            </p>
          </li>
          <li className="dboo-protection-points__item">
            <span className="dboo-protection-points__number">3</span>
            <p className="dboo-protection-points__description">
              Aura will send removal requests to{' '}
              <strong className="dboo-protection-points__description--strong">
                junk mailers
              </strong>
              ,{' '}
              <strong className="dboo-protection-points__description--strong">
                telemarketers
              </strong>
              , and{' '}
              <strong className="dboo-protection-points__description--strong">
                marketing data brokers
              </strong>{' '}
              for free.
            </p>
          </li>
        </ul>
      </div>
    </div>
  );
};
